export default "__VITE_ASSET__DRmwOq1U__"